import { SeatSelectionContext } from '@/context/SeatSelectionContext';
import { useContext } from 'react';

export const useSeatSelection = () => {
  const context = useContext(SeatSelectionContext);

  if (!context) {
    throw new Error(
      'useSeatSelection must be used within a SeatSelectionProvider'
    );
  }

  return context;
};
